import { combineReducers } from "redux";

import schedule_control from "./schedule_control";
import dashboard from "./dashboard";

export default combineReducers({
  schedule_control,
  dashboard,
});
